// Texty ikony dopravy zdarma na detailu produktu (freeShipMark.js).
export default {
  /** značka vpravo dole na fotce, pod ikonou náklaďáku */
  mark: 'zdarma',
  /** řádek v nákupním boxu: tučná část + zbytek */
  rowStrong: 'Doprava zdarma',
  rowRest: 'na výdejní místo',
};
